
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { GetStaticProps } from 'next';
import Stack from '@mui/material/Stack';
import ResponsiveContainer from 'components/atomic/organisms/responsive-container';
import MainLayout from 'components/layouts/main-layout';
import Text from 'components/atomic/atoms/text';
const FourOFour = React.memo(() => {
    return (<MainLayout isFluid headerType="only-logo" title="Not found">
            <ResponsiveContainer maxWidth="lg">
                <Stack pt={3} spacing={2} textAlign="center" alignItems="center">
                    <Text variant="h1" sx={{ wordBreak: 'break-all' }}>
                        FFFFFFFOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOUROFOOOURRRRRRRRRRRRRRRRRR
                    </Text>
                </Stack>
            </ResponsiveContainer>
        </MainLayout>);
});
export default FourOFour;
const getStaticProps: GetStaticProps = async ({}) => {
    return {
        props: {},
    };
};

    async function __Next_Translate__getStaticProps__18916ceb20d__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb20d__ as getStaticProps }
  